import React, { useState, useEffect } from "react";
import { Grid,
  Select,
  OutlinedInput,
  MenuItem, } from "@material-ui/core";
import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../components/PageTitle";
import Widget from "../../components/Widget";
import Table from "../dashboard/components/Table/Table";

import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import firebase from "../../firebase.js"

// data
import mock from "../dashboard/mock";

var database = firebase.database();
function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}
function createOfftrackData(Date, Shift, EngineNumber, Model, Timestamp, Remarks) {
  return {Date, Shift, EngineNumber, Model, Timestamp, Remarks};
}

export default function Tables() {
  
  var lossData = [];
  var defectData = [];
  var summaryData = [];
  var offtrackArray=[];
  var laydownArray=[];
  var rejectionArray=[];
  //var modelSummary=[];

  const [startDateState, setStartDate] = React.useState(new Date('2020-12-18'));
  const [endDateState, setEndDate] = React.useState(new Date('2020-12-20'));
  var [lineState, setLineState] = useState("B");
  var [summaryState, setSummaryDataState] = useState(summaryData);
  var [lossState, setLossDataState] = useState(lossData);
  var [defectState, setDefectDataState] = useState(defectData);
  var [offtrackDataState, setOfftrackDataState] = useState(offtrackArray);
  var [laydownDataState, setLaydownDataState] = useState(laydownArray);
  var [rejectionDataState, setRejectionDataState] = useState(rejectionArray);
  //var [modelSummaryState, setModelSummaryState] = useState(modelSummary)

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  useEffect(() => {
    var dateShiftComb=[];
    var summaryData=[];
    var ref = database.ref('ENS5/zone/'+lineState+'/indexData').orderByKey().startAt(formatDate(startDateState)).endAt(formatDate(endDateState));
    //console.log(ref);
    ref.on('value', function(snapshot) {
      lossData=[];
      var len=0;
      snapshot.forEach(function(dateSnapshot) {
        //console.log("loop1");
        dateSnapshot.forEach(function(shiftSnapshot){
          if(dateShiftComb.indexOf(dateSnapshot.key+shiftSnapshot.key)===-1)
          {
           dateShiftComb.push(dateSnapshot.key+shiftSnapshot.key);
           summaryData.push([dateSnapshot.key,shiftSnapshot.key,0,0,0,0,0,0,0,0,0]);
          }
          var loss=0.0;
          //console.log("loop2");
          shiftSnapshot.forEach(function(indexSnapshot){
            //console.log("loop3");
            lossData.push([dateSnapshot.key, 
              shiftSnapshot.key, indexSnapshot.key, 
              (indexSnapshot.child("delay").val()/234).toFixed(2),//change cycle time 
              indexSnapshot.child("reason").val(),
              indexSnapshot.child("category").val(),
              indexSnapshot.child("station").val(),
              indexSnapshot.child("operatorCode").val(),
              indexSnapshot.child("engineModel").val()]);
            loss=loss+(indexSnapshot.child("delay").val()/234).toFixed(2);
          });
          summaryData[dateShiftComb.indexOf(dateSnapshot.key+shiftSnapshot.key)][5]=loss-len;
          len=len+loss;
        });
      });
    setSummaryDataState(summaryState=>summaryData);
    setLossDataState(lossState=>lossData);
    console.log(lossState);
    console.log(summaryState);
    });

    var ref3 = database.ref('ENS5/zone/'+lineState+'/Offtrack').orderByKey().startAt(formatDate(startDateState)).endAt(formatDate(endDateState));
      ref3.on('value', function(snapshot) {
        offtrackArray=[];
        var len=0;
          snapshot.forEach(function(dateSnapshot) {
            //console.log("loop1");
            dateSnapshot.forEach(function(shiftSnapshot){
              if(dateShiftComb.indexOf(dateSnapshot.key+shiftSnapshot.key)===-1)
              {
              dateShiftComb.push(dateSnapshot.key+shiftSnapshot.key);
              summaryData.push([dateSnapshot.key,shiftSnapshot.key,0,0,0,0,0,0,0,0,0]);
              }
              //console.log("loop2");
              var modelArray=[];
              var modelCount=[];
              shiftSnapshot.forEach(function(childSnapshot){
                //console.log("loop3");
                if(modelArray.indexOf(childSnapshot.child("Model").val())===-1){
                modelArray.push(childSnapshot.child("Model").val());
                modelCount[modelArray.indexOf(childSnapshot.child("Model").val())]=1;
                }
                else
                modelCount[modelArray.indexOf(childSnapshot.child("Model").val())]++;
                offtrackArray.push([dateSnapshot.key, shiftSnapshot.key, childSnapshot.child("Engine Number").val(), childSnapshot.child("Model").val(), childSnapshot.child("Timestamp").val(),  childSnapshot.child("Remarks").val()])
              });
              var str="";
              for(var k=0;k<modelArray.length;k++)
              str=str+modelArray[k]+":"+modelCount[k]+"\n";             
              var i =dateShiftComb.indexOf(dateSnapshot.key+shiftSnapshot.key);
              summaryData[i][2]=offtrackArray.length-len;
              len=len+offtrackArray.length;  
              summaryData[i][11]=str;
              //laydown temporary formula, to be changed
              summaryData[i][4]=summaryData[i][3]+summaryData[i][2];

              summaryData[i][8]=((summaryData[i][2]-summaryData[i][6])*100/(summaryData[i][2]+summaryData[i][3])).toFixed(2);
              summaryData[i][9]=((summaryData[i][2]*100)/(summaryData[i][2]+summaryData[i][3])).toFixed(2);
          });
        });
        setSummaryDataState(summaryState=>summaryData);
        setOfftrackDataState(offtrackDataState=>offtrackArray);
        console.log(offtrackDataState);
        console.log(summaryState);
    });

    {/*
    var ref4 = database.ref('ENS5/zone/'+lineState+'/Laydown').orderByKey().startAt(formatDate(startDateState)).endAt(formatDate(endDateState));
    ref4.on('value', function(snapshot) {
      laydownArray=[];
      var len=0;
      snapshot.forEach(function(dateSnapshot) {
        console.log("loop1");
        dateSnapshot.forEach(function(shiftSnapshot){
          if(dateShiftComb.indexOf(dateSnapshot.key+shiftSnapshot.key)===-1)
              {
              dateShiftComb.push(dateSnapshot.key+shiftSnapshot.key);
              summaryData.push([dateSnapshot.key,shiftSnapshot.key,0,0,0,0,0,0,0,0,0]);
              }
          //console.log("loop2");
          shiftSnapshot.forEach(function(childSnapshot){
            //console.log("loop3");
              laydownArray.push([dateSnapshot.key, shiftSnapshot.key, childSnapshot.child("Engine Number").val(), childSnapshot.child("Model").val(), childSnapshot.child("Timestamp").val(),  childSnapshot.child("Remarks").val()])
          });
          summaryData[dateShiftComb.indexOf(dateSnapshot.key+shiftSnapshot.key)][4]=laydownArray.length-len;   
          len=len+laydownArray.length;   
        });
      });
      setSummaryDataState(summaryState=>summaryData);
      setLaydownDataState(laydownDataState=>laydownArray);
      console.log(laydownDataState);
      console.log(summaryState);
    });
  */}

    var ref5 = database.ref('ENS5/zone/'+lineState+'/Rejection').orderByKey().startAt(formatDate(startDateState)).endAt(formatDate(endDateState));
    ref5.on('value', function(snapshot) {
      rejectionArray=[];
      var len=0;
      snapshot.forEach(function(dateSnapshot) {
        //console.log("loop1");
        dateSnapshot.forEach(function(shiftSnapshot){
          if(dateShiftComb.indexOf(dateSnapshot.key+shiftSnapshot.key)===-1)
              {
              dateShiftComb.push(dateSnapshot.key+shiftSnapshot.key);
              summaryData.push([dateSnapshot.key,shiftSnapshot.key,0,0,0,0,0,0,0,0,0]);
              }
          //console.log("loop2");
          shiftSnapshot.forEach(function(childSnapshot){
            //console.log("loop3");
              rejectionArray.push([dateSnapshot.key, shiftSnapshot.key, childSnapshot.child("Engine Number").val(), childSnapshot.child("Model").val(), childSnapshot.child("Timestamp").val(), childSnapshot.child("Remarks").val()])
          }); 
          var i =dateShiftComb.indexOf(dateSnapshot.key+shiftSnapshot.key);
          summaryData[i][3]=rejectionArray.length-len;  
          len=len+rejectionArray.length; 

          //laydown temporary formula, to be changed
          summaryData[i][4]=summaryData[i][3]+summaryData[i][2];

          summaryData[i][8]=((summaryData[i][2]-summaryData[i][6])*100/(summaryData[i][2]+summaryData[i][3])).toFixed(2);
          summaryData[i][9]=((summaryData[i][2]*100)/(summaryData[i][2]+summaryData[i][3])).toFixed(2); 
        });
      });
      setSummaryDataState(summaryState=>summaryData);
      setRejectionDataState(rejectionDataState=>rejectionArray);
      console.log(rejectionDataState);
      console.log(summaryState);
    });

    var ref6 = database.ref('ENS5/zone/'+lineState+'/Defect Data').orderByKey().startAt(formatDate(startDateState)).endAt(formatDate(endDateState));
    console.log(ref);
    ref6.on('value', function(snapshot) {
      defectData=[];
      var len=0;
      snapshot.forEach(function(dateSnapshot) {
        //console.log("loop1");
        dateSnapshot.forEach(function(shiftSnapshot){
          //console.log("loop2");
          var defective=[];
          var rework=[];
          if(dateShiftComb.indexOf(dateSnapshot.key+shiftSnapshot.key)===-1)
              {
              dateShiftComb.push(dateSnapshot.key+shiftSnapshot.key);
              summaryData.push([dateSnapshot.key,shiftSnapshot.key,0,0,0,0,0,0,0,0,0]);
              }
          shiftSnapshot.forEach(function(defectSnapshot){
            //console.log("loop3");
            defectData.push([dateSnapshot.key, 
              shiftSnapshot.key, defectSnapshot.child("Defect Name").val(), 
              defectSnapshot.child("Subcategory").val(),
              defectSnapshot.child("Observation").val(),
              defectSnapshot.child("Category").val(),
              defectSnapshot.child("Engine Number").val(),
              defectSnapshot.child("Engine Model").val(),
              defectSnapshot.child("Zone").val(),
              defectSnapshot.child("Station").val(),
              defectSnapshot.child("Detected At").val(),
              defectSnapshot.child("Rectification Status").val(),
              defectSnapshot.child("Operator Code").val(),
              defectSnapshot.child("Timestamp").val(),
              defectSnapshot.child("AddRemarks").val(),]);
            if(defective.indexOf(defectSnapshot.child("Engine Number").val())===-1)
            defective.push(defectSnapshot.child("Engine Number").val());
            if(defectSnapshot.child("Rectification Status").val()==="RECTIFIED"&&rework.indexOf(defectSnapshot.child("Engine Number").val())===-1)
            rework.push(defectSnapshot.child("Engine Number").val());
            });
            var i =dateShiftComb.indexOf(dateSnapshot.key+shiftSnapshot.key);
            summaryData[i][7]=defective.length;
            summaryData[i][6]=rework.length;
            summaryData[i][10]=defectData.length-len;
            len=len+defectData.length;  

            //summaryData[i][6]=summaryData[i][7]-summaryData[i][3];
            summaryData[i][8]=((summaryData[i][2]-summaryData[i][6])*100/(summaryData[i][2]+summaryData[i][3])).toFixed(2);
            summaryData[i][9]=((summaryData[i][2]*100)/(summaryData[i][2]+summaryData[i][3])).toFixed(2);
        });
      });
    setSummaryDataState(summaryState=>summaryData);
    setDefectDataState(defectState=>defectData);
    console.log(defectState);
    console.log(summaryState);
    });
    

    return() => {
      ref.off();
      ref3.off();
      //ref4.off();
      ref5.off();
      ref6.off();
      }
  
    }, [startDateState, endDateState, lineState])

  return (
    <>
      <PageTitle title="Index Data" />
      <Grid align="center" alignItems="center" container spacing={4}>
      <Grid item lg={4} md={6} sm={6} xs={16}>
        <Select
                  value={lineState}
                  onChange={e => setLineState(e.target.value)}
                  input={
                    <OutlinedInput
                      labelWidth={0}
                    />
                  }
                  autoWidth
                >
                  <MenuItem value="B">B zone</MenuItem>
                  <MenuItem value="C">C zone</MenuItem>
                  <MenuItem value="TESTING">Testing</MenuItem>
                  <MenuItem value="DRESSING">Dressing</MenuItem>
                  <MenuItem value="RECTIFICATION">Rectification</MenuItem>
                </Select>
                </Grid>
        <Grid item lg={4} md={6} sm={6} xs={16}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          margin="normal"
          id="date-picker-dialog"
          label="Start Date"
          format="yyyy-MM-dd"
          value={startDateState}
          onChange={handleStartDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        </MuiPickersUtilsProvider>
        </Grid>
      <Grid item lg={4} md={6} sm={6} xs={16}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          margin="normal"
          id="date-picker-dialog"
          label="End Date"
          format="yyyy-MM-dd"
          value={endDateState}
          onChange={handleEndDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        </MuiPickersUtilsProvider>
        </Grid>
       </Grid>


      <Grid container spacing={4}>
      <Grid item xs={12}>
          <MUIDataTable
            title="Production Summary"
            data={summaryState}
            columns={["Date", "Shift", "Output", "Rejection", "Total",  "Loss", "Rework", "Defectives","Rework Straight pass","Straight pass", "Total Defects", "Modelwise Summary"]}
            options={{
              filterType: "checkbox",
            }}
          />
          </Grid>
        <Grid item xs={12}>
          <MUIDataTable
            title="Index Loss List"
            data={lossState}
            columns={["Date", "Shift", "Index", "Loss","Reason", "Category", "Station", "Operator Code", "Engine Model"]}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <MUIDataTable
            title="Defect List"
            data={defectState}
            columns={["Date", "Shift", "Defect", "Sub category", "Observation", "Responsibility","Engine Number", "Model","Zone", "Station", "Detected at", "Rectification Status", "Operator Code", "Defect Generation Time", "Remarks"]}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <MUIDataTable
            title="Laydown List"
            data={laydownDataState}
            columns={["Date", "Shift", "EngineNumber", "Model", "Timestamp", "Remarks"]}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <MUIDataTable
            title="Offtrack List"
            data={offtrackDataState}
            columns={["Date", "Shift", "EngineNumber", "Model", "Timestamp", "Remarks"]}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <MUIDataTable
            title="Rejection List"
            data={rejectionDataState}
            columns={["Date", "Shift", "EngineNumber", "Model", "Timestamp", "Remarks"]}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
        
      </Grid>
    </>
  );
}
